"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import { DataSetModel } from "@/models/dataset.model";
export let ErrorModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.datas = new DataSetModel();
    this.total = 0;
  }
};
ErrorModel.model = "errors";
ErrorModel = __decorateClass([
  Annotation.ModelMeta
], ErrorModel);
export let ErrorItemModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.code = "";
    this.message = "";
  }
};
ErrorItemModel.model = "error";
ErrorItemModel = __decorateClass([
  Annotation.ModelMeta
], ErrorItemModel);
